import m from "./../../../dist/es2015/locales/fi_FI.js";
export const am5locales_fi_FI = m;